import { useMemo } from "react";
import { InvoiceData } from "../../../../../redux/types";
import { useAppSelector } from "../../../../../redux/store";
import ExcelExport from "../../../../../utils/Excelexport";
import {
  getExportData,
  getExportDataFacture,
} from "../../../../../utils/api/user.api";
import { splitInvoicesByType } from "../../../../../utils/invoice-type";
import { useReload } from "../../../../guest/hooks";
import FacturesTable from "../../../../tables/admin/FacturesTable/FacturesTable";
import ListeFactureEmiseComtabiliteTable from "../../../../tables/comptabilite/ListeFactureComtabiliteTable/ListeFactureEmiseComtabiliteTable";

// Les documents scannés de l'utilisateur, séparés en dépenses et en factures
// émises scannées : ils vivent dans la même collection.
function useUserInvoices(uid: string) {
  const invoices = useAppSelector((s) => s.invoices);
  return useMemo(
    () => splitInvoicesByType(invoices.filter((i) => i.userId === uid)),
    [invoices, uid]
  );
}

function ScanneesTab({
  data,
  fileName,
}: {
  data: InvoiceData[];
  fileName: string;
}) {
  const categories = useAppSelector((s) => s.categories);
  return (
    <div className="bg-white p-3">
      <div className="flex-sb align-items-center mb-4">
        <div className="tab-dash-admin-filter-container"></div>
        <ExcelExport
          getFileData={() => getExportData(data, categories)}
          fileName={`${fileName}_${new Date().getTime()}`}
        />
      </div>
      <FacturesTable data={data} isLoading={false} func={() => null} />
    </div>
  );
}

function TabsFacture({ state }) {
  const { depenses } = useUserInvoices(state.uid);
  return <ScanneesTab data={depenses} fileName="Factures_depenses" />;
}

export default TabsFacture;

export function TabsFactureEmiseScannee({ state }) {
  const { emisesScannees } = useUserInvoices(state.uid);
  return (
    <ScanneesTab data={emisesScannees} fileName="Factures_emises_scannees" />
  );
}

export function TabsFactureEmise({ state }) {
  const factures = useAppSelector((s) => s.factures);
  const reload = useReload();
  const refetch = () => reload("invoices");
  const data = useMemo(() => {
    return factures.filter((i) => i.userId === state.uid);
  }, [factures]);

  return (
    <div className="bg-white p-3">
      <div className="flex-sb align-items-center mb-4">
        <div className="tab-dash-admin-filter-container"></div>
        <ExcelExport
          getFileData={() => getExportDataFacture(data)}
          fileName={`Factures_${new Date().getTime()}`}
        />
      </div>
      <ListeFactureEmiseComtabiliteTable
        invoices={data}
        isLoading={false}
        reload={() => refetch()}
        userId={undefined}
      />
    </div>
  );
}
